module.exports = __webpack_public_path__ + "img/ico-badge.ba2b9a93.svg";